import React, { useState } from 'react';
// @ts-ignore
import styles from './ManagerWorkplaceCreateOptionsListItem.module.scss';
import { WorkplaceType } from '../../../Enums/WorkplaceType.enum';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import ManagerWorkplaceCreateModal from './ManagerWorkplaceCreateModal';
import Text from '../../../../../Components/Base/Text/Text';

export interface DynamicWorkplaceItem {
	type: WorkplaceType;
	label: string;
	formScheme: ItemScheme[];
}

interface Props {
	item: DynamicWorkplaceItem;
	onSuccess: () => void;
}

const ManagerWorkplaceCreateOptionsListItem: React.FC<Props> = ({
	item,
	onSuccess,
}) => {
	const [isCreateOpen, setIsCreateOpen] = useState(false);

	const handleOnSuccess = () => {
		setIsCreateOpen(false);
		onSuccess();
	};

	return (
		<>
			<div className={styles.wrapper} onClick={() => setIsCreateOpen(true)}>
				<div className={styles.content}>
					<Text className={styles.title} tx={item.label} />
				</div>
				<img src='/dist/icons/circle-plus-regular-full.svg' alt='plus' />
			</div>
			{isCreateOpen && (
				<ManagerWorkplaceCreateModal
					isOpen
					onClose={() => setIsCreateOpen(false)}
					type={item.type}
					formScheme={item.formScheme}
					onSuccess={handleOnSuccess}
				/>
			)}
		</>
	);
};

export default ManagerWorkplaceCreateOptionsListItem;
